<template>
  <div>
    <ui-stage v-if="data">
      <el-alert
        v-if="showReadonlyNotice"
        type="info"
        :closable="false"
        show-icon
        class="mb"
      >
        您正在以只读模式查看监理巡查数据，仅监理单位可编辑。
      </el-alert>
      <ui-tabs v-model="tab" type="border-card">
        <ui-tab-pane name="main" label="详情">
          <ui-admin-form
            :compact="compact"
            :readonly="isReadonly"
            :fields="attributes"
            :model="data"
            :module-url="moduleUrl"
            :with-delete="false"
            @submit="handleSubmit"
          />
        </ui-tab-pane>
      </ui-tabs>
    </ui-stage>
  </div>
</template>

<script>
import { _ } from '@yishitec/web';
import { adminEdit } from '@yishitec/web/mixins';
import permissions from '../../../mixins/permissions';

export default {
  name: 'SupervisionPlogsEdit',
  mixins: [adminEdit, permissions],
  computed: {
    projectId() {
      return _.get(this.data, 'projectId') || _.get(this.data, 'project_id');
    },
    /** 是否对当前记录有写权限 */
    canWrite() {
      if (this.isSuperAdmin) return true;
      return this.amI(this.projectId, '监理单位', '管理人员', true);
    },
    /** 是否对当前记录至少有读权限（建设单位 / 监理单位 / 超管） */
    canRead() {
      if (this.isSuperAdmin) return true;
      if (!this.projectId) return true; // 新建无项目时先不拦截
      return (
        this.amI(this.projectId, '监理单位') ||
        this.amI(this.projectId, '建设单位', '管理人员', true)
      );
    },
    isReadonly() {
      // 满足以下任一条件即为只读：后端强制 / 当前用户无写权限
      if (this.vReadonly) return true;
      if (!this.canWrite) return true;
      return false;
    },
    showReadonlyNotice() {
      return this.isReadonly && !this.isSuperAdmin;
    },
  },
  watch: {
    projectId(value) {
      // 没有权限读时直接给出提示
      if (value && !this.canRead) {
        this.$message?.({
          type: 'error',
          message: '您没有权限查看该项目下的监理巡查数据',
        });
        this.$router?.back();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.mb {
  margin-bottom: 12px;
}
</style>
